<!-- 日历 -->
<template>
    <div class="calendar">
        <div class="month">
            <div class="menu">
                <i class="el-icon-caret-left" @click="prevMonth"></i>
                <span>{{ date.getFullYear() }}年{{ date.getMonth() + 1 }}月</span>
                <i class="el-icon-caret-right" @click="nextMonth"></i>
            </div>
        </div>
        <el-calendar v-model="date">
            <template slot="dateCell" slot-scope="{date, data}">
                <div class="content" @click="onDateChange(date)">
                    <img class="green" src="../assets/home/green.png" alt="" v-if="courseObj.hasOwnProperty(data.day)">
                    <span class="day">{{ data.day.split('-').slice(1)[1] }}</span>
                    <template v-if="courseObj.hasOwnProperty(data.day)">
                        <div class="course_item" v-for="(item, index) in courseObj[data.day]" :key="index" @click="goCourse(item.courseProjectId)">
                            <img class="yellow" src="../assets/home/yellow.png" alt="">
                            <el-tooltip placement="right" popper-class="myTooltip">
                                <span class="name">{{ item.lessonsName }}</span>
                                <div slot="content" class="tip_box">
                                    <div class="time">
                                        <span>{{ item.lessonsBeginDate }}</span>
                                        <span>共<span class="blue">{{ courseObj[data.day].length }}节</span>课</span>
                                    </div>
                                    <span class="name">{{ item.lessonsName }}</span>
                                    <div class="teaInfo">
                                        <img src="../assets/home/avatar.png" alt="">
                                        <span>主讲教师:{{ item.teacherName }}</span>
                                        <div class="status">{{ courseStatur[item.status] }}</div>
                                    </div>
                                </div>
                            </el-tooltip>
                        </div>
                    </template>
                </div>
            </template>
        </el-calendar>
    </div>
</template>
<script>
export default {
    data() {
        return {
            date: new Date(),
            // hideAfter:10000
            courseObj: {},
            courseStatur: {
                unstart: "未开始",
                start: "上课中",
                end: "已下课"
            }
        }
    },
    methods: {
        prevMonth() {
            let currentDate = this.date;
            let currentMonth = currentDate.getMonth();
            this.date = new Date(currentDate.getFullYear(), currentMonth - 1, 1);
            this.getCourse()
        },
        nextMonth() {
            let currentDate = this.date;
            let currentMonth = currentDate.getMonth();
            this.date = new Date(currentDate.getFullYear(), currentMonth + 1, 1);
            this.getCourse()
        },
        //  Api.Home.getNews(params)
        getCourse() {
            // 获取当前时间
            let currentDate = this.date;
            // 获取年份
            let year = currentDate.getFullYear();
            // 获取月份（注意月份从0开始，所以需要加1）
            let month = currentDate.getMonth() + 1;
            // 格式化年份和月份
            let formattedDate = `${year}-${month.toString().padStart(2, '0')}`;
            let data = {
                month: formattedDate
            };
            Api.Home.GetTimetable(data)
                .then(res => {
                    // console.log('课程表:', res);
                    this.courseObj = res.data;
                    // console.log(res.data['2023-08-04'])
                })
                .catch(err => {
                    console.log('获取课程表失败:', err)
                })
        },
        onDateChange(date) {
            // console.log('当前选择的日期是:',date);
            // this.date = date;
            // this.getCourse()
        },
        goCourse(id) {
          this.$emit('goCourse',id)
        },
    },
    mounted() {
        this.getCourse()
    },
};
</script>
<style lang='less' scoped>
@import url("./less/calendar.less");
</style>